import React from "react";
import { useReactiveVar } from "@apollo/client";
import { currentSport } from "src/services/ApolloService";

//  Render the score cell - who W 100-90 or L 90-99
const ScoreCell = ({ scheduleItem, isHome }: { scheduleItem: any; isHome: boolean }) => {
  const league = useReactiveVar(currentSport);
  const selfTeamScore = scheduleItem[`${isHome ? "home" : "away"}Score`];
  const opponentTeamScore = scheduleItem[`${isHome ? "away" : "home"}Score`];

  if (selfTeamScore === null) {
    return <span className="schedule-list__table-cell">--</span>;
  }

  const isDraw = selfTeamScore === opponentTeamScore;
  const won = !isDraw && selfTeamScore > opponentTeamScore;
  return (
    <span className={`schedule-list__table-cell-${isDraw ? "neutral" : won ? "good" : "bad"}`}>
      <span className="schedule-list__self-team-score">
        {isDraw ? (league?.name === "NFL" ? "T" : "D") : won ? "W" : "L"}
      </span>
      <span>{selfTeamScore + "-" + opponentTeamScore}</span>
    </span>
  );
};

export default ScoreCell;
